import { Subject } from 'rxjs';
import { logger } from './logger';
const key = '__active_tab';
const restore_key = '__active_tab_restore';
const _restore$ = new Subject();
window.addEventListener('storage', (event)=>{
    if (event.storageArea !== localStorage || event.key !== restore_key || event.newValue == null) {
        return;
    }
    _restore$.next();
});
_restore$.subscribe(()=>{
    logger.debug('restoring active tab');
    const saved = window.sessionStorage.getItem(key);
    if (saved == null) {
        logger.warn('no saved active tab to restore to');
    }
    window.location.replace(saved !== null && saved !== void 0 ? saved : '/');
});
const save = ()=>{
    logger.debug('saving active tab');
    const value = window.location.href;
    window.sessionStorage.setItem(key, value);
    logger.debug('saved active tab', {
        value
    });
};
// Save only when no value has been captured yet. Useful inside auth flows that may
// run AFTER an upstream redirector has already saved the user's original landing
// URL — calling plain save() at that point would overwrite the good value with
// the post-redirect URL (e.g. /login?token=…).
const saveIfEmpty = ()=>{
    if (window.sessionStorage.getItem(key) != null) {
        logger.debug('active tab already saved, skipping');
        return;
    }
    save();
};
const clear = ()=>{
    logger.debug('clearing active tab');
    window.sessionStorage.removeItem(key);
    logger.debug('cleared active tab');
};
const restore = ()=>{
    _restore$.next();
    localStorage.setItem(restore_key, 'val');
    localStorage.removeItem(restore_key);
};
const pop = ()=>{
    const saved = window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    return saved;
};
export const ActiveTab = {
    save,
    saveIfEmpty,
    pop,
    clear,
    restore
};
